var map = {
	"./en/btn_gift_2.png": "TA6K",
	"./es/btn_gift_2.png": "kqQT",
	"./pt/btn_gift_2.png": "yjv8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iOzo";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_gift_2\.png$
// module id = iOzo
// module chunks = 0